<div id="joint-container">
   <div
      *ngIf="isEditable && isNodeSelector && !isOnlyCanvas"
      class="joint-palette surface-0 surface-border node-drag-padding"
   >
      <app-node-drag-drop [workflow]="workflow" [graph]="getGraph()" (nodeDrag)="setDraggedNode($event)">
      </app-node-drag-drop>
   </div>

   <div id="myJointPaper"></div>
   <app-graph-controllers
      [isEditable]="isEditable"
      [graph]="graph!"
      [paper]="paper!"
      [panZoom]="panZoom"
      [centerZoom]="manualCenterZoom"
      (onZoomIn)="zoomIn()"
      (onZoomOut)="zoomOut()"
      (onOrderNodes)="redrawOrdered()"
   />

   <app-node-inspector-new [mode]="inspectorMode!" *ngIf="isNodeParameters && !isOnlyCanvas"></app-node-inspector-new>
</div>

<p-toast></p-toast>
